<template>
  <Button
    size="icon"
    variant="ghost"
    type="button"
    aria-label="Remove file"
    @click="deleteFile(index)"
  >
    <slot>
      <Trash />
    </slot>
  </Button>
</template>

<script lang="ts">
import { defineComponent, inject } from 'vue'
import { Trash } from 'lucide-vue-next'
import { Button } from "@/components/ui/button";

export default defineComponent({
  components: {
    Trash, Button
  },
  props: {
    index: {
      type: [String, Number],
      default: ''
    }
  },
  setup() {
    return {
      deleteFile: inject<(index: string | number) => void>('deleteFile', () => {})
    }
  }
})
</script>
